import { requests } from "@/db/dbManag";
import { API, STATI_TORNEO, RUOLI } from "@/enums/costanti";
import store from "@/store";

export const getRuoliUtente = () => {
  return Array.isArray(store.getters.ruoli) ? store.getters.ruoli : [];
};

export const utenteHaRuolo = (ruolo) => {
  return getRuoliUtente().includes(ruolo);
};

export const getDataFromApi = (keys, apiLink) => {
  return requests.dbManag.post(apiLink, keys).then((res) => {
    return res.data.result ? res.data.result : res.data;
  });
};
export const getDataFromListApi = (keys, apiLink) => {
  return requests.dbManag
    .post(apiLink, keys)
    .then((res) => {
      const status = res.status;
      const list = Object.values(res.data)[0];
      const record = res.data.record;
      // const { results, record, campi_Locked, comandi_Locked } = Object.values(res.data)[0];
      return { list, status, record };
    })
    .catch((e) => {
      const parsedResponse = JSON.parse(e.request.response);
      return {
        results: [],
        record: 0,
        campi_Locked: [],
        comandi_Locked: [],
        status: e.request.status,
        message: parsedResponse.message,
      };
    });
};

export const getDataFromListApiGet = (keys, apiLink) => {
  return requests.dbManag
    .get(apiLink, { params: { ...keys } })
    .then((res) => {
      const status = res.status;
      const list = Object.values(res.data)[0];
      const record = res.data.record;
      // const { results, record, campi_Locked, comandi_Locked } = Object.values(res.data)[0];
      return { list, status, record };
    })
    .catch((e) => {
      return {
        results: [],
        record: 0,
        campi_Locked: [],
        comandi_Locked: [],
        status: e.request.status,
      };
    });
};

export const getlookupFromApi = (keys) => {
  return requests.dbManag.post(API.LOOKUP_GET, keys).then((res) => {
    return res.data.result ? res.data.result : res.data;
  });
};
export const getLookupRegioniProvincie = (id_regione) => {
  return requests.dbManag

    .post(API.LOOKUP_REGIONI_PROVINCIE, { id_regione })
    .then((res) => {
      if (id_regione) {
        return res.data.istat_regioni_province[0].Province;
      }
      return res.data.istat_regioni_province;
    });
};
export const getLookupRegioniProvincieFe = (id_regione) => {
  return requests.dbManag

    .post(API.LOOKUP_REGIONI_PROVINCIE_FE, { id_regione })
    .then((res) => {
      if (id_regione) {
        return res.data.istat_regioni_province[0].Province;
      }
      return res.data.istat_regioni_province;
    });
};
export const getLookupTorneiEventiCalendario = (id_settore) => {
  return requests.dbManag

    .post(API.LOOKUP_TORNEI_EVENTI_CALENDARIO, {
      id_settore,
      nuovi_eventi: utenteHaRuolo(RUOLI.AMMINISTRATORE) ? false : true,
    })
    .then((res) => {
      return res.data.tornei_eventi_calendario;
    });
};

export const getLookupCircuiti = (id_settore, isPrimario, data_riferimento) => {
  return requests.dbManag

    .post(API.LOOKUP_CIRCUITI, {
      id_settore,
      primario: isPrimario,
      data_riferimento,
    })
    .then((res) => {
      return res.data.circuiti;
    });
};
export const getLookupCircuitiPrimari = (
  id_settore,
  isPrimario,
  data_riferimento
) => {
  return requests.dbManag

    .post(API.LOOKUP_CIRCUITI_PRIMARI, {
      id_settore,
      primario: isPrimario,
      data_riferimento,
    })
    .then((res) => {
      return res.data.circuiti;
    });
};
export const getLookupImpianti = (id_societa, anno) => {
  return requests.dbManag

    .post(API.LOOKUP_IMPIANTI, { id_societa, anno })
    .then((res) => {
      return res.data.results;
    });
};
export const getLookupTorneiTipologie = (id_settore) => {
  return requests.dbManag

    .post(API.LOOKUP_TORNEI_TIPOLOGIE, { id_settore })
    .then((res) => {
      return res.data.tornei_tipologie;
    });
};
export const getLookupComposizioneTorneiSquadre = (
  id_disciplina,
  id_formula_svolgimento
) => {
  return requests.dbManag
    .post(API.LOOKUP_TORNEI_COMPOSIZIONE_SQUADRE, {
      id_disciplina,
      id_formula_svolgimento,
    })
    .then((res) => {
      return res.data.squadre_tornei_composizione_incontri;
    });
};
export const getLookupTorneiCategorieEta = (id_settore) => {
  return requests.dbManag
    .post(API.LOOKUP_SETTORI_TESSERAMENTO_CATEGORIE_ETA_GET, { id_settore })
    .then((res) => {
      return res.data.settori_categorie_eta;
    });
};

export const getLookupGruppoSettore = (
  id_settore,
  id_tipologia,
  utilizzo_tornei_individuali,
  utilizzo_tornei_squadre,
  sociale
) => {
  return requests.dbManag

    .post(API.LOOKUP_TORNEI_SETTORI_GRUPPI, {
      id_settore,
      id_tipologia,
      utilizzo_tornei_individuali,
      utilizzo_tornei_squadre,
      sociale,
    })
    .then((res) => {
      return res.data.tornei_settori_gruppi;
    });
};

export const getLookupLimitePower = (id_settore_gruppo, id_tipologia) => {
  return requests.dbManag

    .post(API.LOOKUP_TORNEI_SETTORI_GRUPPI_P_RANGE, {
      id_settore_gruppo,
      id_tipologia,
    })
    .then((res) => {
      return res.data.settori_gruppi_tipologie_power_range;
    });
};

export const getLookupLimitePowerSquadre = (id_settore_gruppo) => {
  return requests.dbManag
    .post(API.LOOKUP_TORNEI_SETTORI_GRUPPI_P_RANGE_SQUADRE, {
      id_settore_gruppo,
    })
    .then((res) => {
      return res.data.settori_gruppi_power_range;
    });
};

export const getLookupTipologieTabelloni = (
  id_formula_svolgimento,
  id_stato,
  nr_iscrizioni
) => {
  return requests.dbManag
    .post(API.LOOKUP_TORNEI_TABELLONI_DIMENSIONI, {
      id_formula_svolgimento,
    })
    .then((res) => {
      const result = [];
      // nr_iscrizioni = 15;

      res.data.tornei_tabelloni_dimensioni.forEach((dimensione_tab) => {
        if (
          nr_iscrizioni <= dimensione_tab.iscritti_min ||
          nr_iscrizioni <= dimensione_tab.iscritti_max ||
          (nr_iscrizioni >= dimensione_tab.iscritti_min &&
            nr_iscrizioni < dimensione_tab.iscritti_max)
        ) {
          result.push(dimensione_tab);
        }
      });
      return id_stato == STATI_TORNEO.APPROVATO
        ? result
        : res.data.tornei_tabelloni_dimensioni;
    });
};

export const getLookupGareGruppiFase = (
  id_settore,
  id_tipologia_torneo,
  senza_assegnazione_punti
) => {
  return requests.dbManag
    .get(
      API.LOOKUP_TORNEI_FORMULE_SVOLGIMENTO_TABELLONI +
        `?id_settore=${id_settore}&id_tipologia_torneo=${id_tipologia_torneo}`
    )
    .then((res) => {
      const formule = res.data.tornei_formule_svolgimento_tabelloni;

      if (senza_assegnazione_punti === false) {
        return formule.filter((formula) => formula.id !== 22);
      }

      return formule;
    });
};

export const getLookupTorneiPremi = (isDoppio) => {
  return requests.dbManag

    .post(
      API.LOOKUP_TORNEI_PREMI,
      isDoppio
        ? {
            singolo: false,
            doppio: true,
          }
        : {
            singolo: true,
            doppio: false,
          }
    )
    .then((res) => {
      return res.data.tornei_premi;
    });
};

export const getLookupGironiCombinazioni = (id_tabellone) => {
  return requests.dbManag

    .post(API.LOOKUP_TORNEI_GIRONI_COMBINAZIONI, {
      id_tabellone,
    })
    .then((res) => {
      return res.data.gironi_combinazioni;
    });
};
export const getLookupGironiCombinazioniCampionato = (id_tabellone) => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRE_GIRONI_COMBINAZIONI, {
      id_tabellone,
    })
    .then((res) => {
      return res.data.gironi_combinazioni;
    });
};
export const getLookupCampionatoSquadre = (id_settore) => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRE_CAMPIONATI, {
      id_settore,
      iscrizioni_attive: null,
      archiviato: false,
    })
    .then((res) => {
      return res.data.squadre_campionati;
    });
};
export const getLookupZonaSquadre = (id_campionato_squadre) => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRE_ZONA, {
      id_campionato_squadre,
    })
    .then((res) => {
      return res.data.squadre_zona;
    });
};
export const getLookupZonaCampionatiRegione = (id_campionato_squadre) => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRE_CAMPIONATI_REGIONI_ZONE_GET, {
      id_campionato_squadre,
    })
    .then((res) => {
      return res.data.squadre_regioni_zone;
    });
};
export const getLookupGiornoDisponibili = () => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRA_GIORNI_DISPONIBILI, {})
    .then((res) => {
      return res.data.squadre_giorni_disponibili_in_casa;
    });
};
export const getLookupFasi = () => {
  return requests.dbManag.post(API.LOOKUP_SQUADRE_FASI, {}).then((res) => {
    return res.data.squadre_fasi;
  });
};
export const getLookupRuoli = () => {
  return requests.dbManag

    .post(API.LOOKUP_SISTEMA_RUOLI_GET, { tipo: 1 })
    .then((res) => {
      return res.data.ruoli;
    });
};
export const getLookupOrariDisponibili = (id_giorno) => {
  return requests.dbManag

    .post(API.LOOKUP_SQUADRA_ORARI, { id_giorno })
    .then((res) => {
      return res.data.squadre_orari;
    });
};

export const getListaSocietaCoordinatori = (id_persona) => {
  return requests.dbManag

    .post(API.ANAGRAFICA_SOCIETA_COORDINATORI_LIST, { id_persona })
    .then((res) => {
      return res.data.results[0].societa;
    });
};

export const getTipologieAssistenza = () => {
  return requests.dbManag.post(API.LOOKUP_TIPOLOGIE_ASSISTENZA).then((res) => {
    return res.data.assistenza_tipologie;
  });
};
